/**
 * Per-tab client id, sent as `X-Client-Id` with every API request. The backend
 * copies it into `data.changed` events so a tab can ignore its own echo.
 * A module constant (not sessionStorage) so duplicated tabs get distinct ids.
 */
export const CLIENT_ID: string = crypto.randomUUID();
